import React, { useCallback, useState } from "react";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";

import StyledButton from "../../atoms/StyledButton/StyledButton";
import Text from "../../atoms/Text/Text";
import { usePostQuotationMutation } from "../../../rtk/quotations/quotations";
import { RootState } from "../../../types/rtk/api-config/types";
import { useAppSelector } from "../../../rtk/_config/hooks";
import SpinnerLoader from "../../atoms/SpinnerLoader/SpinnerLoader";

const Footer = () => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const chosen_rate = useAppSelector(
    (state: RootState) => state.rates.chosen_rate
  );
  const [postQuotation] = usePostQuotationMutation();

  const handlerInput = useCallback(async () => {
    setIsLoading(true);
    try {
      const response = await postQuotation({
        chosenRate: chosen_rate ?? 0,
      }).unwrap();
      console.log("Response :", response);
      setIsLoading(false);
      window.location.replace(response.url);
    } catch (error) {
      console.log("Error :", error);
      setIsLoading(false);
    }
  }, [chosen_rate, postQuotation]);

  return (
    <Box component={"footer"} className="Footer">
      <Box className="FooterContainer">
        <Text children={t("santevet:FOOTER.TEXT")} />
      </Box>
      {!isLoading ? (
        <StyledButton onClick={handlerInput}>
          {t("santevet:FOOTER.BUTTON")}
        </StyledButton>
      ) : (
        <SpinnerLoader />
      )}
    </Box>
  );
};

export default Footer;
